import {Component, ElementRef, HostListener, OnChanges, OnInit, Renderer2} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {ActivatedRoute, NavigationEnd, ParamMap, Router} from '@angular/router';
import {Element} from '@angular/compiler';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {environment} from '../../../environments/environment';
import {empty} from 'rxjs';
import {AppService} from '../../services/app.service';
import UIkit from 'uikit';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Title} from '@angular/platform-browser';

// import * as icogz from '../../../assets/js/icogz.js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  // device identification
  public deviceInfo;
  public isMobile;
  public isDesktopDevice;

  selectedCity = '';


  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private loadingBar: LoadingBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private el: ElementRef,
    protected $gaService: GoogleAnalyticsService,
    private appService: AppService,
    private deviceService: DeviceDetectorService,
    private titleService: Title,
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe((params) => {
      localStorage.setItem('city', params.city);
    });

    this.loadingBar.start();
    this.$gaService.pageView('/home', 'Home');
    // icogz.trackView('/home', '{referrer URL}', 'cfc5e900-f375-4683-a0bd-38b383f4c8f5');

    this.selectedCity = this.appService.getCurrentCity();

    this.titleService.setTitle('Things2do - Home');

    if (!this.appService.islocationSetByTheUser()) {
      UIkit.modal('.citymodel').show();
    }
  }

  videoVolumeControl(e): void {
    const x = $(e).attr('src');
    (x == 'assets/images/icons/sound.png') ? $(e).attr('src', 'assets/images/icons/mute.png') : $(e).attr('src', 'assets/images/icons/sound.png');
    (x == 'assets/images/icons/sound.png') ? $(e).parents('.image').find('video').prop('muted', true) : $(e).parents('.image').find('video').prop('muted', false);
  }

  playVideo(e): void {
    e.play();
  }

  pauseVideo(e): void {
    e.pause();
  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    if ($($event.target).scrollTop() > 600) {
      $('.scrollup').fadeIn();
    } else {
      $('.scrollup').fadeOut();
    }
  }

  scrollToTop(e): void {
    $('html, body').animate({
      scrollTop: 0
    }, 600);
  }

}
